<template>
<div id="AssetSalePost" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="purchaseorderHeader"> Asset Bill of Sale</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backToList">
                    <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content assetbill-sale">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="AssetSaleForm">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">#Unit :</label>
                                        <span class="col label">{{unit_no}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">Unit Type :</label>
                                        <span class="col label">{{truck_type}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">Assigned Facility :</label>
                                        <span class="col label">{{assigned_facility}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">Year :</label>
                                        <span class="col label">{{year}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">#VIN :</label>
                                        <span class="col label">{{vin}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">Make :</label>
                                        <span class="col label">{{make}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">Model :</label>
                                        <span class="col label">{{model}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">Telephone :</label><br/>
                                        <span class="col label">{{telephone}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">Misc. Charges:</label>
                                        <span class="col label">${{amountFormat(miscellaneous_charge)}}</span>
                                    </div>
                                </div>
                                <div class="col form-group mt-4 pt-1">
                                    <div class="form-row">
                                        <label class="col">Balance:</label>
                                        <span class="col">${{amountFormat(balance)}}</span>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <div class="clearfix"></div>
                                <div class="col form-group">
                                    <label class="control-label require" for="vendor_id">Sales Person:</label>
                                    <v-select v-model="sales_person_id" name="sales_person_id" id="sales_person_id"
                                            label="text" :filterable="false" :options="representativeArr"
                                            placeholder="Select Sales Person">
                                    </v-select>
                                    <div class="field-error">{{ sales_person_error_msg }}</div>
                                </div>

                                <div class="col form-group">
                                    <label class="control-label require" for="customer_id">Customer:</label>
                                    <v-select v-model="customer_id" name="customer_id"
                                            label="text" :filterable="false" :options="customerArr"
                                            @search="onSearchCustomer" :disabled="custDisableFlag"
                                            placeholder="Select Customer" class="custom-ci-auto-search">
                                        <template slot="no-options">
                                            Search Customer...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="field-error" id="customererror">{{ customererrors }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="start_date">Disposal Date:</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="disposal_date" name="disposal_date" v-model="disposal_date" :config="optionsDate"></date-picker>
                                        <label for="disposal_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{ disposal_date_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="selling_facility">Disposal Type:</label>
                                    <v-select v-model="sales_type" name="sales_type" placeholder="Select Sales Type." label="text" :options="saleTypeArr" @input="onChangeSaleType($event)">
                                    </v-select>
                                    <div class="field-error">{{ disposal_type_error_msg }}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="selling_facility">Owning Facility:</label>
                                    <v-select v-model="selling_facility" name="selling_facility" placeholder="Select Location." label="text" :options="locationArr">
                                    </v-select>
                                    <div class="field-error">{{ selling_facility_error_msg }}</div>
                                </div>

                                <div class="col form-group">
                                    <label class="control-label" for="method">Selling Price</label>
                                    <input type="text" :disabled="true" v-model="sold_price" id="sold_price" @input="changeListPriceVal($event,'price');" name="sold_price" placeholder="Selling Price" class="form-control">
                                </div>

                                <div class="col form-group">
                                    <label class="control-label" for="method">DIST</label>
                                    <input type="text" v-model="miles" id="miles" name="miles" placeholder="Miles" class="form-control">
                                </div>
                            </div>
                            <hr class="light-hr"/>
                            <div class="credit-customer-section-main">
                                <h5 class="color-blue font-semibold">Charges</h5>
                                <div class="purchase-order-create-main invoice-list-table table-responsive-sm">
                                    <table aria-describedby="table" class="table table-bordered table-sm">
                                        <thead>
                                            <tr class="table-primary">
                                                <!-- <th scope="col">Charge Code</th> -->
                                                <th scope="col">Charge Name</th>
                                                <th scope="col" class="text-right">Amount</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="chargesArr && chargesArr.length > 0">
                                                <tr v-for="(row, index) in chargesArr" :key="'charge_entry' + index">
                                                    <!-- <td scope="col">{{row.description}}</td> -->
                                                    <td scope="col">{{row.description}}</td>
                                                    <td scope="col" class="text-right">${{amountFormat(row.amount)}}</td>
                                                    <td>
                                                        <a href="javascript:void(0)" title="Remove Charge" v-on:click.prevent="removeCharge(row.code,row.amount);">
                                                            &nbsp;&nbsp;&nbsp;<i class="fp-remove"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr><td scope="col" colspan="4"></td></tr>
                                            </template>
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <hr class="light-hr"/>
                            <div class="credit-customer-section-main">
                                <h6 style="color:red">{{depNotFoundMsg}}</h6>
                                <h5 class="color-blue font-semibold">GL Entry</h5>
                                <div class="purchase-order-create-main invoice-list-table table-responsive-sm" v-if="disposalDetailsArr && disposalDetailsArr.length > 0">
                                    <table aria-describedby="table" class="table table-bordered table-sm">
                                        <thead>
                                            <tr class="table-primary">
                                                <!-- <th scope="col">Charge Code</th> -->
                                                <th scope="col">Charge Name</th>
                                                <th scope="col">GL Code</th>
                                                <th scope="col">Description</th>
                                                <th scope="col" class="text-right">Debit</th>
                                                <th scope="col" class="text-right">Credit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(row, index) in disposalDetailsArr">
                                                <tr :key="'gl_entry' + index">
                                                    <!-- <td scope="col" v-if="row.charge_code == 'DISPOSALTITLEFEE'">{{row.charge_desc}}</td> -->
                                                    <!-- <td scope="col">{{row.charge_desc}}</td> -->
                                                    <td scope="col">{{row.charge_desc}}</td>
                                                    <td scope="col">{{row.gl_code}}</td>
                                                    <td scope="col">{{row.gl_description}}</td>
                                                    <td scope="col" class="text-right">{{row.debit_amount}}</td>
                                                    <td scope="col" class="text-right">{{row.credit_amount}}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" id="CreateAssetSaleBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetSale('next')" v-if="showNext">
                                    <i class="fp-save"> </i> Next
                                </button>
                                <button type="submit" id="CreateAssetSaleBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetSale('post_only')" v-if="!showNext">
                                    <i class="fp-save"> </i> Post Only
                                </button>
                                <button type="submit" id="CreateAssetSaleBtn" class="btn btn-primary" v-on:click.prevent="CreateAssetSale('final')">
                                    <i class="fp-save"> </i> Post Invoice
                                </button>
                                <button type="submit" id="CancelAssetSaleBtn" class="btn btn-tertiary" v-on:click.prevent="backToList">
                                    <i class="fp-close"> </i> Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                    <div class="modal fade wo-message-modal" id="wo-message-modal" ref="woMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="woMessageModal" aria-hidden="true">
                        <div :class="`loader${loaderClass}`" v-show="loading">
                        </div>
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Message</h5>
                                    <button type="button" class="close" id="btnwoModalMessageClose" v-on:click="hidewoMessageModal()">&times;</button>
                                </div>
                                <div class="modal-body">
                                    <div class="form-group alert-success p-2">
                                        <span>This unit is being voided or sold and the following outstanding work order exists:</span>
                                        <div class="d-error color-red">{{wo_no}}&nbsp; open roster entries exist.  </div>
                                        WO:&nbsp;<strong v-fp-html="wo_ref"></strong>
                                        <div>NOTE: Outstanding [not approved] work orders exist for this unit</div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-primary" id="addCreateAssetSaleBtn" v-on:click="postBill(disposalFlag)">
                                        <i class="fp-submit"></i> Ok
                                    </button>
                                    <button type="button" class="btn btn-tertiary" id="cancelwoMessageModal" v-on:click="hidewoMessageModal()">
                                        <i class="fp-close"></i> Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>

<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';


export default {
    name: "AssetSalePost",
    metaInfo() {
        return {
            title: "Bill Asset Sale | " +process.env.COPYRIGHT_NAME
        }
    },
    
    mixins: [commonMixins, contractMixins],
    data: () => ({
        istaxGlSet : false,
        isEdit: false,
        permissions: [],
        locationArr: [],
        cantAccessPage: "",
        vehicle_id: "",
        vehicleArr:[],
        vehicle_error_msg:'',
        loading: false,
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
        vin:'',
        sold_price:'',
        selling_facility:'',
        sales_location:'',
        reconditioning_cost:'',
        net_book_value:'',
        pricing_value:'',
        list_price:'',
        selling_facility_error_msg:'',
        loadOnce:false,
        sales_type:{text:'Retail',value:'retail'},
        saleTypeArr:[
                        {text:'Retail',value:'retail'},
                        {text:'Wholesale',value:'wholesale'},
                        {text:'Lease Buyout',value:'lease buyout'},
                        {text:'Total Loss',value:'total loss'},
                        {text:'Standard Disposal',value:'std'}
                    ],
        sales_person_id:'',
        disposal_type_error_msg:'',
        representativeArr:[],
        telephone:'',
        sales_person_error_msg:'',
        customerArr:[],
        miles:'',
        balance:0.00,
        tax:0.00,
        payments:0.00,
        miscellaneous_charge:0.00,
        damage_reverse:0.00,
        disposal_date_error_msg:'',
        disposal_date:'',
        model:'',
        make:'',
        year:'',
        customererrors:'',
        customer_id:'',
        wo_no:'',
        wo:"no",
        woFlag:false,
        woCalled:false,
        truck_type:'',
        assigned_facility:'',
        unit_no:'',
        disposalDetailsArr:[],
        locationCode: '',
        wo_ref:'',
        chargesArr:[],
        astBillId:0,
        depNotFoundMsg:'',
        custDisableFlag:false,
        showNext:true,
        disposalFlag:'',
    }),

    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_sales') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
        vehicle_id: function(val) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            if(val != null && val != '' && val.value){

                $.ajax({
                    url: process.env.ROOT_API + "/asset/"+val.value,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:"json",

                    success: function (data) {
                        //if data is edit than dont make model id blank
                        if (data.status == "success") {
                            self.vin = data.content.vin;
                            self.unit_no = data.content.unit_no;
                            self.truck_type = data.content.vtCode+' | '+data.content.vtName;
                            self.assigned_facility = data.content.plCode+' | '+data.content.plName;
                            self.net_book_value = data.content.net_book_value;
                            self.make = data.content.vmCode+' | '+data.content.vmName;
                            if (data.content.vmodelsCode != null && data.content.vmodelsCode != ''){

                                self.model = data.content.vmodelsCode+' | '+data.content.vmodelsName;

                            }
                            if (data.content.year != null){

                                self.year = data.content.year;

                            }
                            self.readingDetails();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-data')
                    }
                });
            }

        },
        rows: {
            handler: function (val, oldVal) {
                // Return the object that changed
                var self  = this;
                console.log(self.list_price);

                var index = val.length - 1;
                if (val[index].amount != ''){
                    var total = 0;
                    for(var i = 0;i < val.length;i++){
                        if (val[i].amount != ''){

                            total += parseFloat(val[i].amount);

                        }
                    }
                        // if (val[index].amount > 0){
                        //     if (self.list_price != '' && self.list_price > 0 && self.pricing_value != ''){

                        //         self.list_price =  parseFloat(self.pricing_value) + parseFloat(total);

                        //     }else{

                        //         self.list_price =  parseFloat(total);
                        //     }
                        // }
                    // }
                    // self.list_price = parseFloat(self.list_price) + parseFloat(total);
                }
                console.log(self.list_price);
                console.log(val);
            },
            deep: true
        },
        customer_id: function (customer) {
          // console.log("customer_id ==" , customer);
          if(customer != null) {
            if(this.istaxGlSet == true) {
              console.log("REMOVE ON CHANGE" , this.disposalDetailsArr.length);
                var taxIndex = this.disposalDetailsArr.findIndex(x => (x.gl_description === "Sales Tax Payments"));

                if (taxIndex != undefined && taxIndex != '' && taxIndex >= 0){

                    var amt = this.disposalDetailsArr[0].amount - this.disposalDetailsArr[taxIndex].amount;
                    if (amt > 0){
                        this.disposalDetailsArr[0].amount = amt;
                        this.disposalDetailsArr[0].debit_amount = '$'+this.amountFormat(amt);
                    }

                    this.disposalDetailsArr.splice(taxIndex, 1);
                }
            //   this.disposalDetailsArr.splice((this.disposalDetailsArr.length - 1), 1);
            } else {
              this.istaxGlSet = false;
            }
            this.getTaxDetail(customer.value);
          } else {
            if(this.istaxGlSet == true) {
              console.log("REMOVE ON CLEAR");
                var taxIndex = this.disposalDetailsArr.findIndex(x => (x.gl_description === "Sales Tax Payments"));

                if (taxIndex != undefined && taxIndex != '' && taxIndex >= 0){
                    var amt = this.disposalDetailsArr[0].amount - this.disposalDetailsArr[taxIndex].amount;
                    if (amt > 0){
                        this.disposalDetailsArr[0].amount = amt;
                        this.disposalDetailsArr[0].debit_amount = '$'+this.amountFormat(amt);
                    }
                    this.disposalDetailsArr.splice(taxIndex, 1);
                }
            //   this.disposalDetailsArr.splice((this.disposalDetailsArr.length - 1), 1);
            }
            this.istaxGlSet = false;
          }
          console.log("istaxGlSet ==" , this.istaxGlSet);

        },
        selling_facility: function (selling_facility) {




          if(this.selling_facility != null) {
            this.locationCode = this.selling_facility.value;
            if(this.istaxGlSet == true) {
                var taxIndex = this.disposalDetailsArr.findIndex(x => (x.gl_description === "Sales Tax Payments"));

                if (taxIndex != undefined && taxIndex != '' && taxIndex >= 0){
                    this.disposalDetailsArr.splice(taxIndex, 1);
                }
            //   this.disposalDetailsArr.splice((this.disposalDetailsArr.length - 1), 1);
            } else {
              this.istaxGlSet = false;
            }
            if(this.customer_id != null && this.customer_id != '') {
              this.getTaxDetail(this.customer_id.value);
            }

          } else {
            if(this.istaxGlSet == true) {
                var taxIndex = this.disposalDetailsArr.findIndex(x => (x.gl_description === "Sales Tax Payments"));

                if (taxIndex != undefined && taxIndex != '' && taxIndex >= 0){
                    this.disposalDetailsArr.splice(taxIndex, 1);
                }
            //   this.disposalDetailsArr.splice((this.disposalDetailsArr.length - 1), 1);
            }
            this.locationCode = "";
            this.istaxGlSet = false;
          }
        }

    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {

            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     self.role = userObj.roles[0].name;
            // }

            if ( segments[3]){
                self.loadAssetSale(segments[3]);
                self.astBillId = segments[3];
            }

        }

        setTimeout(function () {
            //self.getPurchaseOrderNo();
            self.added_to_sales_list = moment().format("MM/DD/YYYY");
        }, 500);

        self.getPermissions();
        this.loadFieldData(['depriciation_type','location','disposal_representative']);
        var path = window.location.pathname;
        var segments = path.split("/");

    },
    methods: {

        removeCharge: function (code,amount) {
            
            var self = this;

            self.$swal({
                title: 'Are you sure that you want to remove this charge?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {

                    $.ajax({
                        url: process.env.ROOT_API + "/asset-sale/remove-charge",
                        type: "POST",
                        headers: this.ajxHeaders,
                        dataType: "json",
                        data:{
                            assetSaleBillId:self.astBillId,
                            chargeCode:code,
                            amount:amount
                        },
                        success: function (data) {
                            self.loading = false;
                            console.log(data);
                            self.readingArr = [];

                            if (data.status == "success") {
                                self.loadAssetSale(self.astBillId);
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')

                        }
                    });
                    
                } else {
                    console.log("no");
                }
            });
            
        },
        onChangeSaleType:function(){
            var self = this;

            if (self.sales_type != null && self.sales_type.value && (self.sales_type.value == "wholesale" || self.sales_type.value == "total loss")){
                var taxIndex = self.disposalDetailsArr.findIndex(x => (x.gl_description === "Sales Tax Payments"));

                if (taxIndex != undefined && taxIndex != '' && taxIndex >= 0){
                    var amt = self.disposalDetailsArr[0].amount - self.disposalDetailsArr[taxIndex].amount;
                    if (amt > 0){
                        self.disposalDetailsArr[0].amount = amt;
                        self.disposalDetailsArr[0].debit_amount = '$'+self.amountFormat(amt);
                    }
                    self.disposalDetailsArr.splice(taxIndex, 1);
                }
            }else{
                if(self.customer_id != null && self.customer_id != '') {
                    self.getTaxDetail(self.customer_id.value);
                }
            }
        },
        getTaxDetail: function (customer) {

          var self = this;
          var path = window.location.pathname;
          var segments = path.split("/");

          //to skip sales tax fetch if sale type is wholesale
          if (self.sales_type != null && self.sales_type.value && (self.sales_type.value == "wholesale" || self.sales_type.value == "total loss")){
              return;
          }

          self.loading = true;
          $.ajax({
              url: process.env.ROOT_API + "/gettax_glentry",
              type: "POST",
              headers: this.ajxHeaders,
              dataType: "json",
              data:{
                  customer_id: customer,
                  sold_price: self.sold_price,
                  location_code: self.locationCode,
                  sale_id:segments[3]
              },
              success: function (data) {
                  self.loading = false;

                  if (data.status == "success") {
                    self.istaxGlSet = true;
                    //first remove the tax amount and entry if exists and then add tax entry again with new amount
                    var taxIndex = self.disposalDetailsArr.findIndex(x => (x.gl_description === "Sales Tax Payments"));

                    if (taxIndex != undefined && taxIndex != '' && taxIndex >= 0){
                        var amt = self.disposalDetailsArr[0].amount - self.disposalDetailsArr[taxIndex].amount;
                        if (amt > 0){
                            self.disposalDetailsArr[0].amount = amt;
                            self.disposalDetailsArr[0].debit_amount = '$'+self.amountFormat(amt);
                        }
                        self.disposalDetailsArr.splice(taxIndex, 1);
                    }
                    self.disposalDetailsArr.push(data.content);

//                     var taxIndex = self.disposalDetailsArr.findIndex(x => (x.gl_description === "Truck Sales-receivable"));
// console.log('herer is the tax index: - '+taxIndex);
//                     if (taxIndex != undefined && taxIndex != '' && taxIndex >= 0){
//                         console.log('herer is the tax : - '+taxIndex);
//                         alert('in');
                        var amt = self.disposalDetailsArr[0].amount + data.content.amount;
                        if (amt > 0){
                            self.disposalDetailsArr[0].amount = amt;
                            self.disposalDetailsArr[0].debit_amount = '$'+self.amountFormat(amt);
                        }
                    // }

                  } else {
                    if(self.istaxGlSet == true) {
                      self.disposalDetailsArr.splice((self.disposalDetailsArr.length - 1), 1);
                    } else {
                      self.istaxGlSet = false;
                    }
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')
                  self.istaxGlSet = false;
              }
          });

        },
        onSearchVehicle(search, loading) {
            var self = this;
            if (search.length > 3) {

                loading(true);
                self.searchField(loading, search, 'vehicle', '');
            }

        },

        onSearchCustomer(search, loading) {
            var self = this;
            if (search.length > 2) {

                loading(true);
                self.searchField(loading, search, 'customer', '');
            }
        },

        readingDetails:function(){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/reading-detail-by-vehicle",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_id:self.vehicle_id.value
                },
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    self.readingArr = [];

                    if (data.status == "success") {
                        if (data.content && data.content.length){
                           self.readingArr = data.content;
                           var reading = self.readingArr;

                           reading.forEach(element => {
                               if (element.secCode == 'DIST'){
                                   self.miles = element.reading;
                               }
                           });
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')

                }
            });
        },

        CreateAssetSale(flag) {
            var self = this;
            var error = false;
            self.vehicle_error_msg = "";
            self.selling_facility_error_msg = '';
            self.sales_person_error_msg = '';
            self.disposal_date_error_msg = "";
            self.customererrors = "";
            self.disposal_type_error_msg = '';

            if (self.vehicle_id == null || !self.vehicle_id.value) {
                self.vehicle_error_msg = "Asset is Required.";
                error = true;
            }

            if (self.selling_facility == null || !self.selling_facility.value) {
                self.selling_facility_error_msg = "Facility is Required.";
                error = true;
            }

            if (self.disposal_date == null || self.disposal_date == '') {
                self.disposal_date_error_msg = "Disposal Date is Required.";
                error = true;
            }

            if (self.sales_person_id == null || !self.sales_person_id.value) {
                self.sales_person_error_msg = "Contact is Required.";
                error = true;
            }

            if (self.customer_id == null || !self.customer_id.value) {
                self.customererrors = "Customer is Required.";
                error = true;
            }
            if (self.sales_type == null || !self.sales_type.value) {
                self.disposal_type_error_msg = "Disposal Type is Required.";
                error = true;
            }


            if (!error) {

                if (confirm('Are you sure that you want to Process? ')) {
                    if(self.woCalled == false){
// && flag == 'final'
                        self.getWorkOrder(flag);

                    }else{

                        self.postBill(flag);
                    }
                }


            }
        },
        getWorkOrder: function(flag){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/workorder-by-vehicle/" + self.vehicle_id.value,
                type: "GET",
                headers: this.ajxHeaders,
                data:{
                    flag:'open'
                },
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    self.woCalled = true;
                    if (data.status == "success") {
                        self.woFlag = true;
                        self.wo_no = data.content;
                        self.wo_ref = data.wo_ref;
                        $("#wo-message-modal").modal('show');
                        self.disposalFlag = flag;

                    }else{
                        self.postBill(flag);
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-sale-load')

                }
            });
        },
        postBill:function(flag){
            var self = this;

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            $("#wo-message-modal").modal('hide');

            // if (segments[3]) {
            //     $("#CreateAssetSaleBtn").val("Updating ...");
            //     $("#CreateAssetSaleBtn").prop("disabled", true);
            //     $("#CancelAssetSaleBtn").prop("disabled", true);
            // } else {
            //     if (flag == "Save and Continue") {

            //         $("#CreateAndContinueAssetSaleBtn").val("Saving ...");
            //         $("#CreateAssetSaleBtn").prop("disabled", true);
            //         $("#CreateAndContinueAssetSaleBtn").prop("disabled", true);
            //         $("#CancelAssetSaleBtn").prop("disabled", true);

            //     } else {

            //         $("#CreateAssetSaleBtn").val("Saving ...");
            //         $("#CreateAssetSaleBtn").prop("disabled", true);
            //         $("#CreateAndContinueAssetSaleBtn").prop("disabled", true);
            //         $("#CancelAssetSaleBtn").prop("disabled", true);
            //     }
            // }

            var fields = $("#AssetSaleForm").serializeArray();
            // alert(JSON.stringify(fields));

            if (self.vehicle_id == null) {
                fields.push({
                    name: "vehicle_id",
                    value: ""
                });
            } else {
                fields.push({
                    name: "vehicle_id",
                    value: self.vehicle_id.value
                });
            }

            fields.push({
                name: "flag",
                value: 'bill'
            });

            fields.push({
                name: "final_flag",
                value: flag
            });

            if (self.selling_facility == null) {
                fields.push({
                    name: "selling_facility",
                    value: ""
                });
            } else {
                fields.push({
                    name: "selling_facility",
                    value: self.selling_facility.value
                });
            }

            if (self.sales_type == null) {
                fields.push({
                    name: "sales_type",
                    value: ""
                });
            } else {
                fields.push({
                    name: "sales_type",
                    value: self.sales_type.value
                });
            }

            if (self.sales_person_id == null) {
                fields.push({
                    name: "contact",
                    value: ""
                });
            } else {
                fields.push({
                    name: "contact",
                    value: self.sales_person_id.value
                });
            }

            if (self.customer_id == null) {
                fields.push({
                    name: "customer_id",
                    value: ""
                });
            } else {
                fields.push({
                    name: "customer_id",
                    value: self.customer_id.value
                });
            }

            // var idx = fields.findIndex(obj => obj.name == 'sold_price');
            // if (idx != -1) {
            //   fields.push({
            //       name: "sold_price",
            //       value: parseNum(fields[idx].value.replace(/[^.\d]/g, ''))
            //   });
            //   fields.splice(idx, 1);
            // }
            var a = self.sold_price;

            fields.push({
                  name: "sold_price",
                  value: a.replace(/[^.\d]/g, '')
              });
            fields.push({
                name: "id",
                value: segments[3]
            });

            fields.push({
                name: "disposal_details",
                value: JSON.stringify(self.disposalDetailsArr)
            });

           // console.log(fields); return;
            $.ajax({
                url: process.env.ROOT_API + "/asset-sale/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    // if (segments[3]) {
                    //     $("#CreateAssetSaleBtn").val("Update");
                    //     $("#CreateAssetSaleBtn").prop("disabled", false);
                    //     $("#CancelAssetSaleBtn").prop("disabled", false);
                    // } else {
                    //     if (flag == "Save and Continue") {

                    //         $("#CreateAndContinueAssetSaleBtn").val("Save and Continue");
                    //         $("#CreateAssetSaleBtn").prop("disabled", false);
                    //         $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                    //         $("#CancelAssetSaleBtn").prop("disabled", false);

                    //     } else {

                    //         $("#CreateAssetSaleBtn").val("Save");
                    //         $("#CreateAssetSaleBtn").prop("disabled", false);
                    //         $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                    //         $("#CancelAssetSaleBtn").prop("disabled", false);

                    //     }
                    // }
                    if (data.status == "success") {

                       if (data.content == 'exist'){
                           self.$swal('','Asset Sale Bill Already Generated','info');
                       }else{
                           if (flag == 'final' || data.content.next_id == undefined){

                               if (flag == 'post_only'){
                                   self.$router.push('/asset-sale/list');
                                   return;
                               }
                               if (data.content.customer_name != undefined && data.content.customer_name != ''){
                                    self.customer_id = {text:data.content.customer_name,value:data.content.customer_id};
                                    self.custDisableFlag = true;
                               }
                                self.$router.push("/invoice/asset-sale/view/"+data.content+'?saleId='+segments[3]+'&from=asset-sale-view');
                           }else{
                               //check if more asset sale is exist with same batch
                                self.$router.push('/bill-sale/create/'+data.content.next_id+'?batch='+data.content.next_batch);
                           }
                       }

                    } else {
                        if(data.code == 201){
                            self.$swal('',data.message,'info');
                        }
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3]) {
                        $("#CreateAssetSaleBtn").val("Update");
                        $("#CreateAssetSaleBtn").prop("disabled", false);
                        $("#CancelAssetSaleBtn").prop("disabled", false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#PurchaseOrderForm").trigger("reset");
                            $("#CreateAndContinueAssetSaleBtn").val("Save and Continue");
                            $("#CreateAssetSaleBtn").prop("disabled", false);
                            $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                            $("#CancelAssetSaleBtn").prop("disabled", false);

                        } else {

                            $("#CreateAssetSaleBtn").val("Save");
                            $("#CreateAssetSaleBtn").prop("disabled", false);
                            $("#CreateAndContinueAssetSaleBtn").prop("disabled", false);
                            $("#CancelAssetSaleBtn").prop("disabled", false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-create')

                }
            });
        },

        loadAssetSale(salesId) {
                
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/asset-sale/" + salesId,
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);

                        if (data.status == "success") {
                            var dataSet = data.content.vehicle;
                            self.vehicle_id = {text:dataSet.unit_no+' | '+dataSet.vtCode+' | '+dataSet.vtName+' | '+dataSet.lName,value:dataSet.vehicle_id};
                            self.sold_date = dataSet.sold_date;
                            self.sold_price = self.amountFormat(dataSet.pricing_value);
                            self.next_inspection_date = dataSet.next_inspection_date;
                            self.locationCode = dataSet.selling_facility;
                            self.selling_facility = {text:dataSet.lCode+' | '+dataSet.lName,value:dataSet.selling_facility};
                            setTimeout(function(){

                                self.sales_location = {text:dataSet.saleLocCode+' | '+dataSet.saleLocName,value:dataSet.sales_location};

                            },500);
                            self.telephone = dataSet.telephone;
                            if (dataSet.sales_type == "std") {
                                self.sales_type = {text:"Standard Disposal",value:dataSet.sales_type};
                            }else{
                                self.sales_type = {text:self.titleCase(dataSet.sales_type),value:dataSet.sales_type};
                            }
                            if (dataSet.repId){

                                self.sales_person_id = {text:self.titleCase(dataSet.sales_person_id),value:dataSet.repId};

                            }
                            self.chargesArr = dataSet.charges_item;
                            var total = 0;
                            if (self.chargesArr && self.chargesArr.length){
                                for(var i = 0;i < self.chargesArr.length;i++){
                                    if ( self.chargesArr[i].amount != '') {
                                        total += parseFloat(self.chargesArr[i].amount);

                                    }
                                }
                            }

                            self.miscellaneous_charge = total;
                            self.miles = dataSet.miles;
                            self.disposalDetailsArr = dataSet.disposal_details;

                            if (dataSet.customer_name != undefined && dataSet.customer_name != ''){
                                self.customer_id = {text:dataSet.customer_name,value:dataSet.customer_id_prev};
                                self.custDisableFlag = true;
                            }

                            if (dataSet.next_exist != undefined && dataSet.next_exist == 'true'){
                                self.showNext = true;
                            }else{
                                self.showNext = false;
                            }
                            self.changeListPriceVal('','price');

                            var accFound = 0;
                            if (self.disposalDetailsArr != undefined && self.disposalDetailsArr.length > 0){
                                for(var i=0;i<self.disposalDetailsArr.length;i++){
                                    // if (self.disposalDetailsArr[i].gl_description == 'Truck Inventory - Used Trucks'){
                                    //     accFound = 1;
                                    // }
                                    if (self.disposalDetailsArr[i].dep_found && self.disposalDetailsArr[i].dep_found == 'yes'){
                                        accFound = 1;
                                    }
                                }
                            }

                            if (accFound == 0){
                                self.depNotFoundMsg = 'Accumulated Depreciation Not Found';
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-sale-load')

                    }
                });
            },

        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        isNumberCheck: function (evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf(
                    '.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        backToList: function(){
            var self = this;
            self.$router.push('/asset-sale/list');
        },

        changeListPriceVal:function(evt,flag){
            var self = this;
            if (flag == 'price'){
                if (self.sold_price != ''){

                    var soldPrice = self.sold_price.replace(/[^.\d]/g, '');


                    self.balance = parseFloat(self.miscellaneous_charge) + parseFloat(soldPrice);

                }else{

                    self.balance = parseFloat(self.miscellaneous_charge);
                }
            }
        },
        
        hidewoMessageModal:function(){
            var self = this;
            self.woCalled = false;
            $("#wo-message-modal").modal('hide');
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/asset/PostSaleBill.vue